import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getToken } from 'utils/auth';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const token = getToken();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly) {
    const isAdmin = localStorage.getItem('isAdmin') === 'true';
    // if (!isAdmin) {
    //   return <Navigate to="/dashboard" replace />;
    // }
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;